module.exports = __webpack_public_path__ + "img/Frame_R.915c2f54.png";